export const actionTypes = {
  SET_AUTHDATA: "SET_AUTHDATA",
  CLEAR_DATA: "CLEAR_DATA",
};
